<template>
  <div class="tooltip-container" ref="tooltipContainer">
    <div ref="slotElement" @mouseenter="showTooltip" @mouseleave="hideTooltip">
      <slot></slot>
    </div>
    <div v-if="visible" class="tooltip" :style="tooltipStyle">
      {{ text }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from "vue";

const props = defineProps({ text: String });

const visible = ref(false);
const tooltipStyle = ref({});
const tooltipContainer = ref(null);
const slotElement = ref(null);

const showTooltip = () => {
  console.log("Tooltip wird angezeigt!");
  visible.value = true;
  nextTick(updatePosition);
};

const hideTooltip = () => {
  visible.value = false;
};

const updatePosition = () => {
  if (!slotElement.value) return;

  const parentRect = slotElement.value.getBoundingClientRect();
  tooltipStyle.value = {
    top: `${parentRect.bottom + window.scrollY + 5}px`, 
    right: '0px',
    minWidth: `${parentRect.width}px`,
    position: "absolute",
    zIndex: "9999",
  };
};

onMounted(() => {
  window.addEventListener("resize", updatePosition);
});

onUnmounted(() => {
  window.removeEventListener("resize", updatePosition);
});
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: white; 
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  z-index: 9999;
  display: none;
}

.tooltip-container:hover .tooltip {
  display: block;
}
</style>


  